import type { PaginationRequest } from '@kimuno/api-sdk/lib/types/common';

import userService from '../services/user.service';
import type { ThunkAction } from './common.actionTypes';
import {
	FETCH_RECENTLY_VIEWED,
	type FetchRecentlyViewedAction,
} from './recentlyViewed.actionTypes';

export function fetchRecentlyViewed(
	pagination: PaginationRequest
): ThunkAction<FetchRecentlyViewedAction> {
	const payload = {
		pagination,
	};
	return async (dispatch) => {
		dispatch({ type: FETCH_RECENTLY_VIEWED.START, payload });
		userService
			.getRecentlyViewed(pagination)
			.then((result) => dispatch({ type: FETCH_RECENTLY_VIEWED.SUCCESS, payload, result }))
			.catch((error) => dispatch({ error, type: FETCH_RECENTLY_VIEWED.ERROR, payload }));
	};
}
